import { useEffect } from "react";

export interface PendingQueryState {
  isFetching: boolean;
  isLoading?: boolean;
  isPending?: boolean;
  isError?: boolean;
  isSuccess?: boolean;
  error?: unknown;
  dataUpdatedAt?: number;
}

interface PendingQueryTracker {
  hasPending: (id: string) => boolean;
  complete: (id: string) => boolean;
  fail: (id: string, error: unknown) => boolean;
  unknownErrorMessage: string;
}

export function useTrackPendingQuery(
  id: string,
  state: PendingQueryState,
  { hasPending, complete, fail, unknownErrorMessage }: PendingQueryTracker,
) {
  useEffect(() => {
    if (!hasPending(id)) return;

    const queryInFlight = state.isFetching || state.isLoading || state.isPending;
    if (queryInFlight) return;

    if (state.isError || state.error) {
      fail(id, state.error ?? new Error(unknownErrorMessage));
      return;
    }

    if (state.isSuccess || (state.dataUpdatedAt ?? 0) > 0) {
      complete(id);
    }
  }, [
    complete,
    fail,
    hasPending,
    id,
    state.dataUpdatedAt,
    state.error,
    state.isError,
    state.isFetching,
    state.isLoading,
    state.isPending,
    state.isSuccess,
    unknownErrorMessage,
  ]);
}
